import { FullScreenImagePreviewTrigger } from '../../components/FullScreenImagePreview';
import { LazyImage } from '../../components/LazyImage';

/** The asserting page, with the existing full-screen zoom viewer and a link to the page view. */
export function AuditPageImage({ pageId, src }: { pageId: string; src: string }) {
  return (
    <div className="space-y-2">
      <div className="group relative rounded-lg bg-gray-200 p-1.5 dark:bg-zinc-700">
        <LazyImage src={src} className="w-full overflow-hidden rounded-md" imageClassName="h-auto w-full object-contain" />
        <FullScreenImagePreviewTrigger pageId={pageId} />
      </div>
      <a
        href={`/document-pages/${pageId}`}
        target="_blank"
        rel="noreferrer"
        className="text-sm text-indigo-600 hover:underline dark:text-indigo-400"
      >
        Open the page view
      </a>
    </div>
  );
}
